export default "__VITE_ASSET__47cc92d8__"